import { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import { useDebounce } from "../../hooks/debounce";
import TabbedTable from "../../components/Layout/TabbedTable";
import moment from "moment";
import FaleAPI from "fale";

function Payments(props) {
  const tabs = [
    {
      label: "Transactions",
      statuses: [],
      color: "warning",
      title: "Your transactions will show here",
      type: "Transaction",
      columns: [
        { label: "Transaction ID", value: (trx) => trx.id },
        {
          label: "Amount",
          value: (trx) => `$${(trx.amount / 100).toFixed(2)}`,
        },
        {
          label: "Created On",
          value: (trx) => moment(trx.created, "X").format("DD/MM/YYYY H:mm A"),
        },
      ],
    },
    {
      label: "Payouts",
      statuses: [],
      color: "success",
      title: "Your payouts will show here",
      columns: [
        { label: "Payout ID", value: (trx) => trx.id },
        {
          label: "Total",
          value: (trx) => `$${(trx.amount / 100).toFixed(2)}`,
        },
        {
          label: "Created On",
          value: (trx) => moment(trx.created, "X").format("DD/MM/YYYY H:mm A"),
        },
      ],
    },
  ];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [transactions, setTransactions] = useState({});
  const [payouts, setPayouts] = useState({});
  const [lastItemId, setLastItemId] = useState(null);
  const [stats, setStats] = useState({ total: 0.0, fees: 0.0, payout: 0.0 });

  const debounceRequest = useDebounce(() => {
    if (props.selectedKitchen) {
      if (selectedTab.label === "Transactions") {
        FaleAPI.payments.getTransactions(lastItemId, props.selectedKitchen.id).then((data) => {
          setTransactions(data);
        });
      } else {
        FaleAPI.payments.getPayouts(lastItemId, props.selectedKitchen.id).then((data) => {
          setPayouts(data);
        });
      }

      FaleAPI.payments.getStats(props.selectedKitchen.id).then((data) => {
        setStats(data);
      });
    }
  });

  useEffect(() => {
    debounceRequest();
  }, [props.selectedKitchen, selectedTab, lastItemId, debounceRequest]);

  return (
    <Layout {...props}>
      <div className="row gutters">
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h4>Payments</h4>

          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3">
              <div className="stats-tile2">
                <div className="sale-details">
                  <h2>${stats.total.toFixed(2)}</h2>
                  <p>Total Revenue</p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3">
              <div className="stats-tile2">
                <div className="sale-details">
                  <h2>${stats.fees.toFixed(2)}</h2>
                  <p>Service Fees</p>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 mt-3">
              <div className="stats-tile2">
                <div className="sale-details">
                  <h2>${stats.payout.toFixed(2)}</h2>
                  <p>Total Payout</p>
                </div>
              </div>
            </div>
          </div>

          <TabbedTable
            data={
              selectedTab.label === "Transactions"
                ? transactions.data || null
                : payouts.data || null
            }
            tabs={tabs}
            selectedTab={selectedTab}
            onTabClick={(tab) => () => {
              setSelectedTab(tab);
            }}
            onNextPage={() => {
              setLastItemId(
                transactions.data ? transactions.data.slice(-1)[0]?.id : null
              );
            }}
            showLoadMore={
              transactions?.data?.length &&
              transactions.data.length === 10 &&
              transactions.hasMore
            }
            disableCounts
          />
        </div>
      </div>
    </Layout>
  );
}

export default Payments;
